import script from "./SideMenuCardSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuCardSection.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuCardSection.vue?vue&type=style&index=0&id=3ec530bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec530bc"]])

export default __exports__